import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Alert } from "@mui/material";
import {
  hideMessage,
  showAuthLoader,



  userSignIn
} from "actions/Auth";
import CardBox from "components/CardBox";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { isIOS, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { getItemByUidApi } from "../api/util";
import ProcessTable from "../app/routes/Component/process/ProcessTable.";


class Item extends React.Component {
  constructor() {
    super();
    this.state = {
      item: {},
      lock: true,
      isLangInput: false,
      fileList: [],
      process: [],
      error:false,
    };
  }

  async componentDidMount() {
    const uid = this.props.match.params.uid;

    const result = await getItemByUidApi(uid);
    if (result.status) {
    // //console.log("444444444444444 ", result);
      this.setState({ item: result.data.item, process: result.data.process });
    }


  }




  render() {
    const { item, lock, process } = this.state;

    if (isIOS || isMobile) {
      document.body.classList.add("ios-mobile-view-height");
   //  //console.log("--------------------------------------------- ",isIOS, isMobile)
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
   //  //console.log("--------------------------------------------- ",isIOS, isMobile)
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className="app-wrapper">
      <div className="animated slideInUpTiny animation-duration-3">
   
   
       
            {!lock ? (
              <div className="overflow-auto">
                <div className="row justify-content-center mb-3">
                  <Link to="/">
                    <img
                      src={require("assets/images/says_logo/sonLogo2.png")}
                      alt="Yaysis"
                      title="Sözlük ve Ansiklopedi Yönetim Sistemi"
                    />
                  </Link>
                </div>

                <CardBox
                  styleName="col-md-12 col-xs-12 col-sm-12"
                  heading={<IntlMessages id="item.information" />}
                >
                  <List dense={true}>
                    <Divider light />

                    <ListItem>
                      <ListItemText
                        color="teal"
                        primary={<IntlMessages id="item.title" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={item.title}
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="item.writer" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                          Array.isArray(item.writers)
                            ? item.writers.join(" , ")
                            : item.writers
                        }
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="item.keyword" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                          Array.isArray(item.keyword)
                            ? item.keyword.join(" , ")
                            : item.keyword
                        }
                      />
                    </ListItem>
                    <Divider light />
                  </List>
                </CardBox>

                <ProcessTable
                  processList={process}
                  isAdmin={false}
                  showComment={false}
                  classStyle="overflow-auto col-md-12 col-xs-12 col-sm-12"
                />
              </div>
            ) : (
              <div className="bg-grey"></div>
            )} 
   </div>
            <SweetAlert
              show={this.state.lock}
              input
              confirmBtnText={<IntlMessages id="button.ok" />}
              confirmBtnBsStyle="danger"
              title={<IntlMessages id="showItem.alert.title" />}
              validationMsg={<IntlMessages id="showItem.alert.msg" />}
              onConfirm={(text) => {
             //  //console.log("tettt ", text);
                if (Number(text) === item.id) 
                this.setState({ lock: false });
                else 
                this.setState({error:true})
              }}
              //  style={{backgroundColor:'red'}}
              hideOverlay={false}
               
            >


              <div className="row justify-content-center mb-3">
                <Link className="" to="/">
                  <img
                    src={require("assets/images/says_logo/sonLogo2.png")}
                    alt="Yaysis"
                    title="Sözlük ve Ansiklopedi Yönetim Sistemi"
                  />
                </Link>
              </div>

              {
                this.state.error && <Alert className="mb-2" severity="error">
<IntlMessages id="showItem.alert.error" />
                </Alert>
              }
            </SweetAlert>
{/* 
            <SweetAlert
              show={this.state.error}
              danger
              confirmBtnText={<IntlMessages id="button.ok" />}
              confirmBtnBsStyle="danger"
              title={<IntlMessages id="showItem.alert.error" />}
              onConfirm={() => {
                this.setState({error:false})
              }}
            
            /> */}
            

          </div>
 
  
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
})(Item);
